import React, { useState, Fragment } from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Layout, Menu, Icon, Dropdown, Input as AntInput } from "antd";
import { withRouter, RouteComponentProps } from "react-router";

import routes from "../routes/routes";
import globalColors from "../styles/globalColors";
import Logo from "../assets/images/logo.png";
import { Button } from ".";
import { history } from "../routes";
import { indexSearch } from "../actions/searchActions";
import { logoutAction } from "../actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { redirectTo } from "../utils/searchUtils";
import { AppState } from "../reducers";

const { Header } = Layout;

type Props = RouteComponentProps & {
  selectMenu: (route: string) => void;
};

const Navigation: React.FC<Props> = props => {
  const dispatch = useDispatch();
  const { userInfos } = useSelector((state: AppState) => state);
  const [search, setSearch] = useState("");
  const isLoginPage = props.location.pathname.includes("login");
  const isAuthCallback = props.location.pathname.includes("auth/callback");
  const showNavigation = !isLoginPage && !isAuthCallback;
  const routeKeys = {
    dashboard: routes.dashboard,
    recentActivity: routes.recentActivity,
    customers: routes.customers,
    policies: routes.policies.list,
    quotes: routes.applications.list,
    tasks: routes.tasks
  };

  const { pathname } = props.location;

  const name =
    userInfos && userInfos.firstName && userInfos.lastName
      ? `${userInfos.firstName} ${userInfos.lastName}`
      : "";

  const selectedKeys: string[] = [];
  Object.values(routeKeys).forEach(value => {
    const isRootUrl = value === routes.dashboard;
    if (
      (isRootUrl && pathname === routes.dashboard) ||
      (!isRootUrl && pathname.includes(value))
    ) {
      selectedKeys.push(value);
    }
  });

  const onSearch = () => {
    if (search) {
      dispatch(
        indexSearch(search, (results: SearchListItems[]) => {
          if (results.length === 1) {
            history.push(redirectTo(results[0]));
          } else {
            history.push({
              pathname: routes.search,
              search: `?query=${search}`
            });
          }
        })
      );
    }
  };

  return (
    <Header css={styles.header}>
      <img src={Logo} alt="Logo" css={styles.logo} />
      {showNavigation && (
        <Fragment>
          <div css={styles.rightContainer}>
            <Button onClick={() => history.push("/quote/product")}>
              New Quote
            </Button>
            <div css={styles.searchButtonContainer}>
              <AntInput.Search
                name="search"
                value={search}
                allowClear
                onChange={(event: any) => {
                  setSearch(event.target.value);
                }}
                onSearch={onSearch}
                size="large"
                css={styles.searchButtonStyle}
              />
            </div>
            <div>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <a>Account</a>
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => dispatch(logoutAction(props.history))}
                    >
                      <a>Logout</a>
                    </Menu.Item>
                  </Menu>
                }
              >
                <a href="#" css={styles.accountText}>
                  {name} <Icon type="down" />
                </a>
              </Dropdown>
            </div>
          </div>

          <Menu
            theme="light"
            mode="horizontal"
            selectedKeys={selectedKeys}
            css={styles.menu}
          >
            <Menu.Item
              key={routeKeys.dashboard}
              onClick={() => props.selectMenu(routeKeys.dashboard)}
            >
              Dashboard
            </Menu.Item>
            <Menu.Item
              key={routeKeys.customers}
              onClick={() =>
                props.selectMenu(`${routeKeys.customers}?recentlyViewed=true`)
              }
            >
              Customers
            </Menu.Item>
            <Menu.Item
              key={routeKeys.policies}
              onClick={() =>
                props.selectMenu(`${routeKeys.policies}?recentlyViewed=true`)
              }
            >
              Policies
            </Menu.Item>
            <Menu.Item
              key={routeKeys.quotes}
              onClick={() => props.selectMenu(routeKeys.quotes)}
            >
              Quotes
            </Menu.Item>
            <Menu.Item key="4">Claims</Menu.Item>
            <Menu.Item
              key={routeKeys.tasks}
              onClick={() => props.selectMenu(routeKeys.tasks)}
            >
              Tasks
            </Menu.Item>
            <Menu.Item
              key={routeKeys.recentActivity}
              onClick={() => props.selectMenu(routeKeys.recentActivity)}
            >
              Recent Activity
            </Menu.Item>
          </Menu>
        </Fragment>
      )}
    </Header>
  );
};

const styles = {
  accountText: {
    color: globalColors.primary,
    fontWeight: 500
  },
  header: {
    position: "fixed" as "fixed",
    zIndex: 2,
    width: "100%",
    background: "white",
    borderTop: `10px solid ${globalColors.black}`,
    height: 74,
    padding: 0
  },
  logo: {
    // width: "120px",
    height: "31px",
    margin: "16px 24px 16px 24px",
    float: "left" as "left"
  },
  menu: {
    lineHeight: "64px",
    padding: "0 50px",
    ".ant-menu-item-selected": {
      fontWeight: 600
    }
  },
  rightContainer: {
    marginRight: "24px",
    float: "right" as "right",
    display: "flex",
    alignItems: "center"
  },
  searchButtonContainer: {
    cursor: "pointer",
    marginLeft: 10,
    marginRight: 13
  },
  searchButtonStyle: {
    "input, .ant-select-selection": {
      paddingLeft: 20,
      backgroundColor: globalColors.lightestGray,
      borderColor: globalColors.lightGray,
      borderRadius: 30
    }
  }
};

// @ts-ignore
export default withRouter(Navigation);
